import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import installView from './config/view';
import installBlocks from './config/blocks';
import installReducers from './config/reducers';
import './theme/weather.scss';

function applyConfig(config: ConfigType) {
  installSettings(config);
  installView(config);
  installBlocks(config);
  installReducers(config);

  return config;
}

export default applyConfig;
